import { lazy } from 'react'
import { withSuspense } from 'utils/lazyLoad/lazyWrapper'

const SwitchRoleRegistration = lazy(
  () => import('features/auth/components/SwitchRoleRegistration'),
)
const SwitchRoleRequestPending = lazy(
  () =>
    import(
      'features/auth/components/SwitchRoleRegistration/SwitchRoleRequestPending'
    ),
)

const SwitchRoleRoutes = [
  {
    path: '/switch-role/registration',
    element: withSuspense(SwitchRoleRegistration),
  },
  {
    path: '/switch-role/pending',
    element: withSuspense(SwitchRoleRequestPending),
  },
]

export default SwitchRoleRoutes
